/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AutocompleteAddressResponseAddressesInner } from './AutocompleteAddressResponseAddressesInner';
import {
    AutocompleteAddressResponseAddressesInnerFromJSON,
    AutocompleteAddressResponseAddressesInnerFromJSONTyped,
    AutocompleteAddressResponseAddressesInnerToJSON,
    AutocompleteAddressResponseAddressesInnerToJSONTyped,
} from './AutocompleteAddressResponseAddressesInner';

/**
 * 
 * @export
 * @interface AutocompleteAddressResponse
 */
export interface AutocompleteAddressResponse {
    /**
     * 
     * @type {Array<AutocompleteAddressResponseAddressesInner>}
     * @memberof AutocompleteAddressResponse
     */
    addresses: Array<AutocompleteAddressResponseAddressesInner>;
}

/**
 * Check if a given object implements the AutocompleteAddressResponse interface.
 */
export function instanceOfAutocompleteAddressResponse(value: object): value is AutocompleteAddressResponse {
    if (!('addresses' in value) || value['addresses'] === undefined) return false;
    return true;
}

export function AutocompleteAddressResponseFromJSON(json: any): AutocompleteAddressResponse {
    return AutocompleteAddressResponseFromJSONTyped(json, false);
}

export function AutocompleteAddressResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutocompleteAddressResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'addresses': ((json['addresses'] as Array<any>).map(AutocompleteAddressResponseAddressesInnerFromJSON)),
    };
}

export function AutocompleteAddressResponseToJSON(json: any): AutocompleteAddressResponse {
    return AutocompleteAddressResponseToJSONTyped(json, false);
}

export function AutocompleteAddressResponseToJSONTyped(value?: AutocompleteAddressResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'addresses': ((value['addresses'] as Array<any>).map(AutocompleteAddressResponseAddressesInnerToJSON)),
    };
}

